// Inject this before any script that uses 'routes' in theme.liquid or main-product.liquid:
window.routes = {
  cart_add_url: '/cart/add.js',
  cart_url: '/cart',
  cart: '/cart.js'
};

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      if (document.querySelector('cart-drawer')) {
        if(this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), cartData: response});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const addToCartBtn = document.querySelector('button[name="add"]');
const variantInput = document.querySelector('input[name="id"]');

if (addToCartBtn && variantInput) {
  if (variantInput.value !== "") {
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('disabled');
  } else {
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');
  }
}


  // ✅ Dynamically enable/disable Add to Cart button based on valid variant selection
  document.querySelector('form[action^="/cart/add"]').addEventListener('change', function (event) {
    const updatedVariantInput = this.querySelector('input[name="id"]');
    if (updatedVariantInput && updatedVariantInput.value !== "") {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('disabled');
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('disabled');
    }
  });
});
function normalizeName(name) {
  let n = name.toLowerCase().replace(/[\s-_]+/g, '');
  // Fix common typo here:
  if (n === 'softsawy') n = 'softsway';
  return n;
}

function filterThumbnailsByVariant(variantTitle) {
  const normalizedVariant = normalizeName(variantTitle);

  console.log('Filtering thumbnails for variant:', variantTitle, 'normalized:', normalizedVariant);

  document.querySelectorAll('.thumbnail-list__item').forEach(thumbLi => {
    const img = thumbLi.querySelector('img');
    if (!img) return;

    const normalizedAlt = normalizeName(img.alt);
    const normalizedSrc = normalizeName(img.src);

    if (normalizedAlt.includes(normalizedVariant) || normalizedSrc.includes(normalizedVariant)) {
      thumbLi.style.display = 'block';
    } else {
      thumbLi.style.display = 'none';
    }
  });

  const firstVisibleBtn = Array.from(document.querySelectorAll('.thumbnail-list__item'))
    .filter(li => window.getComputedStyle(li).display !== 'none')
    .map(li => li.querySelector('button.thumbnail'))
    .find(btn => btn !== null);

  if (firstVisibleBtn) firstVisibleBtn.click();
}

function runFilter() {
  const productJsonEl = document.querySelector('[data-product-json]');
  if (!productJsonEl) return;

  const productData = JSON.parse(productJsonEl.textContent);
  const currentVariantId = document.querySelector('input[name="id"]')?.value;
  const currentVariant = productData.variants.find(v => v.id == currentVariantId);

  if (currentVariant) {
    filterThumbnailsByVariant(currentVariant.title);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Initial delayed run to avoid conflicts with other scripts
  setTimeout(runFilter, 500);

  // Listen for radio variant change inputs
  document.querySelectorAll('.product-form__input input[type="radio"]').forEach(swatch => {
    swatch.addEventListener('change', () => {
      runFilter();
    });
  });

  // Listen to Shopify theme variant change event (if your theme emits it)
  document.addEventListener('variant:change', (e) => {
    if (e.detail && e.detail.variant && e.detail.variant.title) {
      filterThumbnailsByVariant(e.detail.variant.title);
    }
  });

  // Observe thumbnail list for changes, reapply filter if detected
  const container = document.querySelector('.thumbnail-list');
  if (container) {
    const observer = new MutationObserver(() => {
      runFilter();
    });

    observer.observe(container, { childList: true, subtree: true });
  }
});
function updateShadeDescription(variantId) {
  const productJsonEl = document.querySelector('[data-product-json]');
  if (!productJsonEl) return;

  const productData = JSON.parse(productJsonEl.textContent);
  const variant = productData.variants.find(v => v.id == variantId);

  if (variant) {
    // If metafields are exposed in product JSON
    const shadeText = variant.metafields?.custom?.shade_description || '';
    const shadeEl = document.getElementById('VariantShadeDescription');
    if (shadeEl) {
      shadeEl.textContent = shadeText;
    }
  }
}

document.addEventListener('variant:change', (e) => {
  if (e.detail && e.detail.variant && e.detail.variant.id) {
    updateShadeDescription(e.detail.variant.id);
  }
});
